module.exports = __webpack_public_path__ + "img/m2.bc893607.png";